// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import $http from './http'
import axios from 'axios'


import './reset.css'
import './public.css'

axios.interceptors.response.use(res => {
  console.log(6666666666666);
  if (res.data.code == -1) {
    router.app.$router.push('login')
  } else if (res.data.code == 1) {
    if (res.data.data && res.data.data.user) {
      store.commit('setUserInfo', res.data.data.user);
    }
  }
  return res;
});

console.log(111111111, store);
// Vue.prototype.baseUrl = 'http://203.105.32.92',
// Vue.prototype.baseUrl = 'http://m.e-game123.com/index.php',
Vue.prototype.baseUrl = '/index.php',
  Vue.prototype.axios = axios;
Vue.prototype.$http = axios;
// Vue.prototype.$http = $http;

Vue.prototype.imgBaseUrl = 'http://m.e-game123.com';

Vue.prototype.addLength = function (n) {
  return n > 9 ? n : '0' + n;
}

Vue.prototype.initDate = function () {
  // 本月不能补读  8月不能补读（暑假） 只有近半年的能补读
  let arr = [];
  let curM = new Date().getMonth()+1;
  let curY = new Date().getFullYear();
  for (let i = 0; i < 6; i++) {
    let m = curM - i;
    let y = curY;
    if (m <= 0) {
      y = y - 1;
      m = 12 + m;
    }
    if (m != 8) {
      arr.push({
        name: y + '年' + m + '月',
        value: y + '-' + this.addLength(m) + '-01'
      })
    } else {
      continue;
    }
  }
  this.list = arr;
  let date = arr[0].value;
  this.getData(date.substring(0, 7));
},

  Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js